import { useGetBotWalletsWithChainId } from "@/api/bot/bot-get-wallets-with-chain-id";
import { getUserId } from "@/helpers/localStorage";
import { BotWalletSupportedChain } from "./types";
import { useWallet } from "./wallet-provider";

export const useBotWallets = () => {
  const userId = getUserId();
  const { appPubKey } = useWallet();

  const { data: solanaWallets, refetch: refetchSolanaWallets } =
    useGetBotWalletsWithChainId({
      appPubKey: appPubKey,
      chainId: BotWalletSupportedChain.SOL,
      userId: userId || "",
    });

  const { data: ethersWallets, refetch: refetchEthereumWallets } =
    useGetBotWalletsWithChainId({
      appPubKey: appPubKey,
      chainId: BotWalletSupportedChain.ETH,
      userId: userId || "",
    });

  return {
    ethersWallets: ethersWallets?.wallets,
    solanaWallets: solanaWallets?.wallets,
    refetch: () => {
      refetchSolanaWallets();
      refetchEthereumWallets();
    },
  };
};
